import { useNavigate } from "react-router-dom";

import DividerText from "../../components/Divider/DividerText/DividerText";
import Typography from "../../components/Typography/Typography";
import LandingImage from "../../assets/landingImage.svg";
import Button from "../../components/Button/Button";
import AuthPageShell from "../../components/AuthPageShell/AuthPageShell";
import styles from "./Landing.module.scss";

const Landing = () => {
	const navigate = useNavigate();

	const handleRegisterClick = () => {
		navigate("/register/validate-identity");
	};

	const handleRedirectClick = () => {
		navigate("/login");
	};

	return (
		<AuthPageShell scrollFooterReserve={false}>
			<div className={styles.landingContainer}>
				<div className={styles.landingImageContainer}>
					<img
						src={LandingImage}
						alt=""
						className={styles.landingImg}
					></img>

					<div className={styles.landingImageContent}>
						<Button
							className={styles.landingImageBtn}
							color="white"
							onClick={handleRegisterClick}
						>
							Crear Cuenta
						</Button>
					</div>
				</div>

				<DividerText text="¿Ya te inscribiste?"></DividerText>

				<Button
					className={styles.landingRedirectBtn}
					onClick={handleRedirectClick}
				>
					Soy Amigo Juan Valdez
				</Button>

				<Typography variant="p2" className={styles.landingAnonimusText}>
					¿Solo quieres explorar?{" "}
					<a
						href="https://juanvaldez.com/"
						target="_blank"
						rel="noopener noreferrer"
						className={styles.landingAnonimusText}
					>
						Ingresa como invitado
					</a>
				</Typography>
			</div>
		</AuthPageShell>
	);
};

export default Landing;
